// Microsoft Authentication Library configuration
import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: '49241182-4ca3-4dd1-9116-66a51d92c17f',
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: window.location.origin
  },
  cache: {
    cacheLocation: "sessionStorage", // Use session storage to make tokens expire when browser is closed
    storeAuthStateInCookie: false, // Set to true for IE11 support
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error('message', message);
            return;
          case LogLevel.Info:
            // console.info('message', message);
            return;
          case LogLevel.Verbose:
            console.debug('message', message);
            return;
          case LogLevel.Warning:
            console.warn('message', message);
            return;
          default:
            return;
        }
      },
      logLevel: LogLevel.Info,
    },
  },
};

// Add scopes for OneDrive API access
export const loginRequest = {
  scopes: [
    "User.Read",
    "Files.Read",
    "Files.Read.All",
    "Files.ReadWrite",
    "Files.ReadWrite.All",
    "Sites.Read.All"
  ],
};

// OneDrive API endpoints
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
  graphDriveEndpoint: "https://graph.microsoft.com/v1.0/me/drive",
};